export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/greenCheckMark.1962be9c.svg","height":33,"width":35,"blurWidth":0,"blurHeight":0};